/**
 * Centralized logger that respects environment.
 *
 * Why:
 *   - Pre-prod (NODE_ENV !== 'production'): forwards everything to console.
 *   - Production: silences `info`/`debug` to keep the browser console clean
 *     while preserving `warn`/`error` for in-the-wild diagnostics (and ready
 *     to be wired to a real telemetry backend later).
 *
 * Usage:
 *   import { logger } from '../utils/logger';
 *   logger.error('failed to load tasks', err);
 */
const isProd = process.env.NODE_ENV === 'production';

export const logger = {
  // No-op in production; visible in dev.
  debug: isProd ? () => {} : (...args) => console.debug(...args),
  info: isProd ? () => {} : (...args) => console.info(...args),
  // Always visible — these signal real problems.
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
